export default "__VITE_ASSET__Crqvy8R9__"